export const convertToCsv = (input: any) => {
  const rows: string[] = [];

  input.forEach((row: any[]) => {
    if (Array.isArray(row[0])) {
      row.forEach((innerRow: any[]) => {
        const csvRow = innerRow
          .map((value: any) => {
            // If the value is a string containing a comma, wrap it in double quotes
            if (typeof value === 'string' && value.includes(',')) {
              return `"${value}"`;
            }
            return value;
          })
          .join('\t');
        rows.push(csvRow);
      });
    } else {
      const csvRow = row
        .map((value: any) => {
          if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
          return value;
        })
        .join('\t');
      rows.push(csvRow);
    }
  });

  return rows.join('\n');
};
